import IAssignHwrcPermissionsRequest from "interfaces/requests/IAssignHwrcPermissionsRequest";
import { GlobalState } from "little-state-machine";

export const updateAssignHwrcPermissionsRequest = (state: GlobalState, assignHwrcPermissionsRequest: IAssignHwrcPermissionsRequest) => ({
  ...state,
  assignHwrcPermissionsRequest
});
